var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "staff-chat-view" }, [
    _c(
      "div",
      { staticClass: "staff-chat-view-search" },
      [
        _c(
          "el-radio-group",
          {
            staticStyle: { "margin-right": "10px" },
            attrs: { size: "small", disabled: _vm.isRequestSuccess },
            on: { change: _vm.selectSearchType },
            model: {
              value: _vm.radio,
              callback: function($$v) {
                _vm.radio = $$v
              },
              expression: "radio"
            }
          },
          [
            _c("el-radio-button", { attrs: { label: "今日" } }),
            _c("el-radio-button", { attrs: { label: "昨日" } }),
            _c("el-radio-button", { attrs: { label: "近7日" } }),
            _c("el-radio-button", { attrs: { label: "近30日" } })
          ],
          1
        ),
        _c("el-date-picker", {
          staticStyle: { width: "240px", "margin-right": "10px" },
          attrs: {
            size: "small",
            editable: false,
            type: "daterange",
            "value-format": "yyyy-MM-dd",
            "range-separator": "~",
            "start-placeholder": "开始日期",
            "end-placeholder": "结束日期",
            disabled: _vm.isRequestSuccess
          },
          on: { change: _vm.dateChange },
          model: {
            value: _vm.searchDate,
            callback: function($$v) {
              _vm.searchDate = $$v
            },
            expression: "searchDate"
          }
        })
      ],
      1
    ),
    _c("div", { staticClass: "below" }, [
      _c(
        "div",
        { staticClass: "l-nav" },
        [
          _c(
            "el-scrollbar",
            [
              _c(
                "el-aside",
                {
                  staticClass: "chat-type",
                  staticStyle: { height: "60vh", width: "100%" }
                },
                [_c("div", { staticClass: "menu-item" }, [_vm._v("沟通客户")])]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "middle" },
        [
          _vm.activePath == "1"
            ? _c("SelectExternalFriend", {
                ref: "selectExternalFriend",
                attrs: { uid: _vm.uid },
                on: { requestSuccess: _vm.requestSuccess }
              })
            : _c("StaffSen", { ref: "StaffSen", attrs: { uid: _vm.uid } })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }